import React from 'react'
import { v4 } from 'uuid'
import { GatsbyImage } from "gatsby-plugin-image";

import './related_pages.css'

function RelatedPages({ relatedPages }) {
  if (!relatedPages) return <div />

  return (
    <div className="section">
      <div className="container-fluid">
        <div className="columns">
          <div className="column is-12 content-section">
            <h2 className="is-size-3 has-text-primary has-text-weight-bold">
              These Might be of Interest
            </h2>
          </div>
        </div>
        <div className="horizontal-scroll-ctr">
          {relatedPages
            .filter((p) => p.link != null)
            .map((p) => (
                <div
                  className="card relatedPage column is-2-desktop is-8-touch is-4-tablet"
                  key={v4()}
                >
                  <div className="card-image">
                    {p.sections.secondaryImage &&
                      p.sections.secondaryImage.localFile && (
                        <GatsbyImage
                          image={p.sections.secondaryImage.localFile.childImageSharp.gatsbyImageData}
                          alt={p.title} />
                      )}
                  </div>
                  <div>
                    <p className="has-text-centered has-text-primary three-lines">
                      {p.title.toLowerCase()}
                    </p>
                    <div className=" has-text-right py-2">
                      <a
                        href={p.link}
                        className="is-size-5 has-text-danger"
                        style={{ margin: '1em' }}
                      >
                        KNOW MORE
                      </a>
                    </div>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
}

export default RelatedPages
